import InputLabel from 'domains/core/components/InputLabel';
import TextField from 'domains/core/components/TextField';
import { updateInteraction } from 'pages/ContentVoiceBuilderPage/voiceCallActions';
import { VoiceContentAction, VoiceContentInteraction, VoiceText } from 'pages/ContentVoiceBuilderPage/types';
import MessageInputWithMergeTags from 'pages/ContentVoiceBuilderPage/MessageInputWithMergeTags';

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    index: number;
    interaction: VoiceContentInteraction;
};

const ActionValueInput = ({ dispatchVoiceContentAction, index, interaction }: Props) => {
    const actionType = interaction?.type;
    const isTransfer = actionType === VoiceContentAction.TRANSFER;
    const actionValue = isTransfer ? interaction?.transferNumber : (interaction?.message?.[0] as VoiceText)?.text;

    if (!actionType) return;

    const handleInteractionChange = (interaction: VoiceContentInteraction) => {
        dispatchVoiceContentAction(updateInteraction(interaction, index));
    };

    const handleTransferNumberChange = (value: string) => {
        const updatedValue = { transferNumber: value };
        const updatedInteraction = {
            ...interaction,
            ...updatedValue,
        };

        handleInteractionChange(updatedInteraction);
    };

    if (isTransfer) {
        return (
            <TextField
                label={
                    <InputLabel
                        label="Transfer Number"
                        labelIconTooltipText="Call will be transferred to this number."
                    />
                }
                multiline={!isTransfer}
                onChange={(e: any) => handleTransferNumberChange(e.target.value)}
                rows={3}
                value={actionValue}
                width="200px"
            />
        );
    }

    const handleMessageChange = (value: string) => {
        const updatedValue = { message: [{ text: value, type: 'text' }] };
        const updatedInteraction = {
            ...interaction,
            ...updatedValue,
        };

        handleInteractionChange(updatedInteraction as VoiceContentInteraction);
    };

    return (
        <MessageInputWithMergeTags
            handleMessageChange={handleMessageChange}
            isMessageLoading={false}
            label="Message"
            message={actionValue}
            rows={3}
            width="400px"
        />
    );
};

export default ActionValueInput;
